import React from 'react';
import { Form, FormControl, FormGroup, Radio } from 'react-bootstrap';
import { find } from 'lodash';

import IconTooltip from './IconTooltip';
import { replaceExpression } from '../utils';
import { CollaboratorsContext } from '../context/CollaboratorsContext';
import Collaboration from './Collaboration';
import CheckmarkQuestionAnswered from './CheckmarkQuestionAnswered';
import * as answerService from "../services/answer-service";


export default class RadioQuestion extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.onChange = this.onChange.bind(this);
    this.obtainRadioDOM = this.obtainRadioDOM.bind(this);
    this.obtainRadioExplanationDOM = this.obtainRadioExplanationDOM.bind(this);
    this.state = {
      showTextBox: false,
      allComments: [],
      comment: ''
    };
  }

  getValue(optionId) {
    const value = find(this.props.state, s => s.optionId === optionId);
    return value ? value.booleanValue : false;
  }

  componentDidMount() {
    var scanId = (this.props.analyse === true)
        ? this.props.originalState[0].scanId
        : (this.props.state && this.props.state[0] ? this.props.state[0].scanId : null);

    if (scanId) {
      answerService.getComments(scanId)
          .then((allComments) => {
            this.setState({ allComments });
          })
          .catch((error) => {
            console.error("Error fetching comments:", error);
          });
    }
  }

  getExplanationValue(data) {
    const { allComments } = this.state;
    if (!allComments) return '';

    const commentEntry = allComments.find((comment) => comment.questionId === data.id);
    return commentEntry ? commentEntry.comment : '';
  }

  handleTexAreaChange(e, data) {
    const updatedComment = e.target.value;

    const saveCommentsToLocalStorage = (questionId, comment) => {
      const commentsFromStorage = localStorage.getItem('comments');
      let commentsArray = commentsFromStorage ? JSON.parse(commentsFromStorage) : [];

      const existingCommentIndex = commentsArray.findIndex(
          (entry) => entry.questionId === questionId
      );

      if (existingCommentIndex > -1) {
        commentsArray[existingCommentIndex].comment = comment;
      } else {
        commentsArray.push({ questionId, comment });
      }

      localStorage.setItem('comments', JSON.stringify(commentsArray));
      console.log("Updated comments saved to localStorage:", commentsArray);
    };

    this.setState({ comment: updatedComment }); // Update local comment state

    const updateAnswer = async () => {
      let scanId = null;

      try {
        if (this.props.isIntroQuestions) {
          saveCommentsToLocalStorage(data.id, updatedComment);
        } else {
          if (this.props.state && this.props.state[0] && this.props.state[0].scanId) {
            scanId = this.props.state[0].scanId;
          } else {
            console.error("Scan ID is not available in props.state");
            return;
          }


          await answerService.updateAnswer({
            scanId: scanId,
            questionId: data.id,
            comment: updatedComment,
          });
        }
      } catch (error) {
        console.error("Failed to update the answer:", error);
      }
    };

    updateAnswer();
  }

  getOriginalValue(optionId) {
    let value = undefined;
    if (this.props.originalState) {
      value = find(this.props.originalState, s => s.optionId === optionId);
    }
    return value ? value.booleanValue : false;
  }

  onChange(e, optionIds, option) {
    this.props.onChange(e, optionIds, true);

    if (option.optionText === 'Anders, namelijk:') {
      this.setState({ showTextBox: true });
    } else {
      this.setState({ showTextBox: false });
    }
  }

  obtainAnsweredCheckDOM(optionIds) {
    let questionHasAnswer = false;

    optionIds.forEach(id => {
      const checked = this.getValue(id);
      if (checked === true) questionHasAnswer = true;
    });

    return <CheckmarkQuestionAnswered checked={questionHasAnswer} />;
  }

  obtainRadioDOM(option, name, completed, answermap, optionIds) {
    // Skip rendering radio options with no text
    if (!option.optionText) {
      return null; // Skip rendering if there is no option text
    }

    return (
        <Radio
            className={this.getOriginalValue(option.id) ? 'original' : ''}
            name={name}
            value={option.id}
            key={option.id}
            disabled={completed}
            checked={this.getValue(option.id)}
            onChange={e => this.onChange(e, optionIds, option)}
        >
          <span className="text">{replaceExpression(option.optionText, answermap)}</span>
        </Radio>
    );
  }

  obtainRadioExplanationDOM(data, completed, answermap, optionIds) {
    return (
        <FormGroup>
          {data.options.map((option, index) => {
            const isLastOption = index === data.options.length - 1;
            const radioOption = this.obtainRadioDOM(option, data.questionNumber, completed, answermap, optionIds);

            if (isLastOption && !this.props.feedback) {
              return (
                  <div key={option.id + index }>
                    {radioOption}
                    <div className="free-text" >
                      <br/>
                      <span>Toelichting:</span>
                      <br/>
                      <FormControl
                          componentClass="textarea"
                          key={option.id}
                          disabled={completed || this.props.analyse}
                          value={this.state.comment || this.getExplanationValue(data)}
                          onChange={(e) => this.handleTexAreaChange(e, data)}
                      />
                    </div>
                  </div>
              );
            }

            return radioOption;
          })}
        </FormGroup>
    );
  }

  render() {
    const { data, completed, answermap, isIntroQuestions, isExtraQuestion, feedback } = this.props;
    const optionIds = data.options.map(option => option.id);

    return (
        <div className="question-group type-radio row">
          <div className="col">
            <Form>
            <span>{replaceExpression(data.questionText, answermap)}
              <div className="indicator-container">
                <IconTooltip text={replaceExpression(data.explanation, answermap)} icon="far fa-info-circle" />
                {this.obtainAnsweredCheckDOM(optionIds)}
              </div>
            </span>

              {!isExtraQuestion && <FormGroup>{
                data.options.map(option => this.obtainRadioDOM(option, data.questionNumber, completed, answermap, optionIds))
              }</FormGroup>}

              {isExtraQuestion && this.obtainRadioExplanationDOM(data, completed, answermap, optionIds)}
            </Form>
          </div>

          {!isIntroQuestions &&
              <CollaboratorsContext.Consumer>
                {context => (
                    <Collaboration
                        data={data}
                        answermap={answermap}
                        collaborators={context.state.collaborators}
                        scanId={context.state.scanId}
                    />
                )}
              </CollaboratorsContext.Consumer>}
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RadioQuestion.js